/**
 * @overview convenience HOC for wrapping a component with an error boundary
 * This is sometimes nicer than declaratively inserting an <ErrorBoundary> around a component's mount site
 * because you can contain all of the error handling rendering and tracking co-located with the component being wrapped
 */

import React from 'react'
import ErrorBoundary from 'components/ErrorBoundary'
import getDisplayName from 'lib/get-display-name'

export default function withErrorBoundary({ errorComponent, onError } = {}) {
  return function(Component) {
    return class WithErrorBoundary extends React.Component {
      static displayName = `WithErrorBoundary(${getDisplayName(Component)})`

      render() {
        return (
          <ErrorBoundary errorComponent={errorComponent} onError={onError}>
            <Component {...this.props} />
          </ErrorBoundary>
        )
      }
    }
  }
}
